module.exports = __webpack_public_path__ + "static/media/plane(4).afcf127f.PNG";